import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const AddproductRightSide = () => {
  return (
    <ProductConsumer>
      {(value) => {
        const {
          AddProChange,
          nrxeFroshtnDenar,
          nrxeFroshtnDolar,
          onSave,
          del_dis,
          openUpdateproduct,
          addnrxKraton,
          zhmaraySht,
          prodactdata,
          search,
          zhmara,
          naweSht,
          barcode,
          open,
          getProductDataBySearchByNumber,
          updtae_Right_product,
          ok,
          close_update,
          error,
          ClearError,
          qazanj,
          calculateNrxDarzan,
          zhmarayKarton,
          kren,
          nrxeKamtrlaDaDarzan,
          nrxeKamtrlanewCarton,
          setProductSearchEmty,
          R_dataTable,
          Add_toanotherInput,
          wazn_karton,
          newPage,
          R_addToTable,
          ProductLoading,
          ProductshowLoader,
          getProductDataBySearch,
          Add_toanotherInputttttt,
          nrxmufrad,
          priceOneRRR,
          OnKrenChange,
          L_user,
          productNum,
          aynamictoanotherInput
        } = value;
        return (
          <div className=" col-12 col-12  col-lg-4 ">
            <div
              className="card card-warning"
              style={{ backgroundColor: "#2C3539" }}
            >
              <div
                className="card-header p-1 row"
                style={{ backgroundColor: "#2C3539" }}
              >
                <div className="col-4 text-white font-weight-bold tc">
                  {/* <input
                    type="text"
                    onChange={AddProChange}
                    value={productNum}
                    onKeyPress={(event) =>
                      event.key == "Enter"
                        ? getProductDataBySearchByNumber(event)
                        : null
                    }
                    name="productNum"
                    className="form-control text-right font-weight-bold px-4 bg-danger text-white tc"
                  />{" "} */}
                </div>
                <div className="col-8">
                  <h3 className="card-title tc text-warning">زیادکردنی کاڵا</h3>
                </div>
              </div>

              <div className="card-body text-warning f4 border border-warning">
                <div className="b--black text-right">
                  {error != null && (
                    <button
                      className="btn btn-success text-right"
                      type="button"
                    >
                      {error.msg ? error.msg : error.error[0].msg}
                      <span
                        className="ml-2  border-black"
                        onClick={() => ClearError()}
                      >
                        X
                      </span>
                    </button>
                  )}
                </div>
                <form onChange={AddProChange}>
                  <div className="row">
                    <div className="col-sm-6 text-right">
                      {/* <div className="form-group">
                        <label className="font-weight-bold">
                          ژمارەی شتەکان
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="zhmaraySht"
                          // onClick={getProductDataBySearchName}
                          onChange={AddProChange}
                          disabled={del_dis == true ? true : null}
                          value={zhmaraySht}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInputttttt(event)
                              : null
                          }
                          className="form-control text-right font-weight-bold"
                        />
                      </div> */}
                    </div>
                    <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">کۆدی کاڵا</label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="zhmara"
                          onChange={AddProChange}
                          disabled={del_dis == true ? true : null}
                          value={zhmara}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 3, "p",getProductDataBySearch)
                              : null
                          }
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <button
                          onClick={(e) => newPage(e)}
                          className={`btn btn-${
                            open ? "danger" : "primary"
                          } mt4 mr4 `}
                          disabled={open && true}
                        >
                          <i className="fas fa-file fa-lg"></i>
                        </button>
                        <button
                          onClick={setProductSearchEmty}
                          className="btn btn-dark mt4 mr5"
                        >
                          <i className="fas fa-search-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">باڕکۆد</label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="barcode"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                          value={barcode}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInput(event)
                              : null
                          }
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div>
                    <div className="col-12 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">ناوی شتەکان</label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="naweSht"
                          disabled={del_dis == true ? true : null}
                          value={naweSht}
                          onChange={AddProChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 2, "p")
                              : null
                          }
                          className="form-control text-right font-weight-bold"
                          maxLength={36}
                        />
                        <br />
                        <div className="row">
                          {/* <div className="col-6">
                            <label className="font-weight-bold">
                              نرخی کارتۆن
                            </label>
                            <input
                              type="text"
                              autoComplete="off"
                              name="addnrxKraton"
                              disabled={del_dis == true ? true : null}
                              // autoComplete="off"
                              value={addnrxKraton}
                              onChange={calculateNrxDarzan}
                              className="form-control text-right font-weight-bold bg-danger text-white"
                            />
                          </div> */}
                          {/* <div className="col-6">
                            <label className="font-weight-bold">
                              نرخی یەک دانە
                            </label>
                            <input
                              type="text"
                              autoComplete="off"
                              name="priceOneRRR"
                              disabled={del_dis == true ? true : null}
                              // autoComplete="off"
                              value={priceOneRRR}
                              onChange={AddProChange}
                              className="form-control text-right font-weight-bold bg-danger text-white"
                            />
                          </div> */}
                        </div>
                      </div>
                    </div>
                         <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">$$$</label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="kren"
                          disabled={del_dis == true ? true : null}
                          onChange={OnKrenChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 3, "p")
                              : null
                          }
                          value={kren}
                          className="form-control text-right font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          دەرزەن لە کارتۆن
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="zhmarayKarton"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                         onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 1, "-")
                              : null
                          }
                          value={zhmarayKarton}
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div>
               

                    <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          ID نرخی فرۆشتن{" "}
                        </label>
                        <NumberFormat
                          displayType="input"
                          thousandSeparator={true}
                          name="nrxeFroshtnDenar"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInput(event)
                              : null
                          }
                          value={nrxeFroshtnDenar}
                          className="form-control text-right font-weight-bold bg-success text-white"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          $ نرخی فرۆشتن{" "}
                        </label>
                        <input
                          autoComplete="off"
                          type="number"
                          name="nrxeFroshtnDolar"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                         onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 1, "-")
                              : null
                          }
                          value={
                            Number(nrxeFroshtnDolar).toFixed(2)
                          }
                          className="form-control text-right font-weight-bold bg-success text-white"
                        />
                      </div>
                    </div>

                    {/* <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          {" "}
                          کەمتر لە 10 دەرزەن
                        </label>
                        <NumberFormat
                          displayType="input"
                          thousandSeparator={true}
                          name="nrxeKamtrlaDaDarzan"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInput(event)
                              : null
                          }
                          value={
                            nrxeKamtrlaDaDarzan
                          }
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          {" "}
                          کەمتر لە نیو کارتۆن
                        </label>
                        <NumberFormat
                          displayType="input"
                          thousandSeparator={true}
                          name="nrxeKamtrlanewCarton"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInput(event)
                              : null
                          }
                          value={
                            nrxeKamtrlanewCarton == 0
                              ? ""
                              : nrxeKamtrlanewCarton
                          }
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div> */}
                    
                    {/* <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">وەزن کارتۆن</label>
                        <input
                          type="number"
                          autoComplete="off"
                          name="wazn_karton"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInput(event)
                              : null
                          }
                          value={wazn_karton}
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div> */}


                    {/* <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold"> دانە لە دەرزەن</label>
                        <NumberFormat
                          displayType="input"
                          thousandSeparator={true}
                          name="NumberOfDana"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInput(event)
                              : null
                          }
                          value={NumberOfDana}
                          className="form-control  text-right font-weight-bold"
                        />
                      </div>
                    </div> */}
                    {/* <div className="col-sm-6 text-right">
                      <div className="form-group">
                        <label className="font-weight-bold">IQD نرخی مفرد</label>
                        <NumberFormat
                          displayType="input"
                          thousandSeparator={true}
                          name="nrxmufrad"
                          disabled={del_dis == true ? true : null}
                          onChange={AddProChange}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? Add_toanotherInput(event)
                              : null
                          }
                          value={nrxmufrad}
                          className="form-control bg-warning text-right font-weight-bold"
                        />
                      </div>
                    </div> */}
                    <div className="col-sm-6 text-left mt-5">
                      <>
                        {search == null ? (
                          <>
                            {ok == null ? (
                              <>
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    ProductshowLoader(e);
                                    onSave(e);
                                  }}
                                  className="btn btn-md  btn-success px-4 ml3"
                                >
                                  <i className="far fa-save fa-lg"></i>
                                </button>
                              </>
                            ) : (
                              <button
                                onDoubleClick={close_update}
                                type="button"
                                className="btn btn-md  btn-success px-4 ml3"
                              >
                                <i className="fas fa-check-double animate__animated animate__heartBeat animate__repeat-2"></i>
                              </button>
                            )}
                          </>
                        ) : ok == null ? (
                          <>
                            {open == null ? (
                              <button
                                onClick={(e) =>
                                  openUpdateproduct(e, prodactdata._id)
                                }
                                disabled={R_addToTable}
                                type="button"
                                className="btn btn-md btn-warning px-4 ml3"
                                style={{
                                  backgroundColor: "silver",
                                  border: "1px solid silver"
                                }}
                              >
                                <i className="fas fa-lock"></i>
                              </button>
                            ) : (
                              <button
                                onClick={(e) =>
                                  updtae_Right_product(e, prodactdata)
                                }
                                type="button"
                                className="btn btn-md btn-primary px-4 ml3"
                                style={{ backgroundColor: "navy" }}
                              >
                                <i className="fas fa-edit fa-lg"></i>
                              </button>
                            )}
                          </>
                        ) : (
                          <>
                            {open == null ? (
                              <button
                                onClick={(e) =>
                                  openUpdateproduct(
                                    e,
                                    prodactdata._id,
                                    L_user._id
                                  )
                                }
                                disabled={R_addToTable}
                                type="button"
                                className="btn btn-md btn-warning px-4 ml3"
                                style={{
                                  backgroundColor: "silver",
                                  border: "1px solid silver"
                                }}
                              >
                                <i className="fas fa-lock"></i>
                              </button>
                            ) : (
                              <button
                                onClick={(e) =>
                                  updtae_Right_product(e, prodactdata)
                                }
                                type="button"
                                className="btn btn-md btn-primary px-4 ml3"
                                style={{ backgroundColor: "navy" }}
                              >
                                <i className="fas fa-edit fa-lg"></i>
                              </button>
                            )}
                            <button
                              onDoubleClick={close_update}
                              type="button"
                              className="btn btn-md  btn-success px-4 ml3"
                            >
                              <i className="fas fa-check-double animate__animated animate__heartBeat animate__repeat-2"></i>
                            </button>
                          </>
                        )}
                      </>
                    </div>
                   
                  </div>
                </form>
              </div>
            </div>
          </div>
        );
      }}
    </ProductConsumer>
  );
};

export default AddproductRightSide;
